(function(){
  if (window.__eoaCartDrawer) return; window.__eoaCartDrawer = true;

  var drawer   = document.querySelector('[data-cd]');
  var backdrop = document.querySelector('[data-cd-backdrop]');
  var body     = document.querySelector('[data-cd-body]');
  var foot     = document.querySelector('[data-cd-foot]');
  var subEl    = document.querySelector('[data-cd-sub]');
  if (!drawer) return;

  var locale = document.documentElement.lang || 'en-GB';
  function money(cents, currency){
    try { return new Intl.NumberFormat(locale, {style:'currency', currency: currency || 'GBP'}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2); }
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function open(){
    drawer.classList.add('on'); backdrop.classList.add('on');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function close(){
    drawer.classList.remove('on'); backdrop.classList.remove('on');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  function updateCount(n){
    document.querySelectorAll('.nav-cart').forEach(function(a){
      a.textContent = n > 0 ? 'Cart (' + n + ')' : 'Cart';
    });
  }

  function render(cart){
    updateCount(cart.item_count);
    if (!cart.items || !cart.items.length){
      body.innerHTML = '<div class="eoa-cd-empty"><p>Nothing here yet.</p>'
        + '<a href="/#collections">Explore the Collections</a></div>';
      foot.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1$2') : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      html += '<div class="eoa-cd-line" data-key="' + esc(it.key) + '">'
        +   '<a class="eoa-cd-thumb" href="' + esc(it.url) + '">'
        +     (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '">' : '')
        +   '</a>'
        +   '<div>'
        +     '<a class="eoa-cd-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>'
        +     (variant ? '<span class="eoa-cd-variant">' + esc(variant) + '</span>' : '')
        +     '<div class="eoa-cd-row">'
        +       '<span class="eoa-cd-qty">'
        +         '<button type="button" data-cd-dec aria-label="Decrease quantity">&#8722;</button>'
        +         '<span>' + it.quantity + '</span>'
        +         '<button type="button" data-cd-inc aria-label="Increase quantity">&#43;</button>'
        +       '</span>'
        +       '<span class="eoa-cd-price">' + money(it.line_price, cart.currency) + '</span>'
        +     '</div>'
        +     '<button type="button" class="eoa-cd-remove" data-cd-rm>Remove</button>'
        +   '</div>'
        + '</div>';
    });
    body.innerHTML = html;
    subEl.textContent = money(cart.total_price, cart.currency);
    foot.style.display = '';
  }

  function fetchCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}, credentials:'same-origin'})
      .then(function(r){ return r.json(); }).then(function(c){ render(c); return c; });
  }

  function change(key, qty){
    drawer.classList.add('busy');
    return fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){ return r.json(); })
      .then(function(c){ render(c); drawer.classList.remove('busy'); })
      .catch(function(){ drawer.classList.remove('busy'); });
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var btn = form.querySelector('[name="add"], button[type="submit"]');
    var label = btn ? btn.innerHTML : null;
    if (btn){ btn.disabled = true; btn.innerHTML = 'Adding&hellip;'; }

    fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
      headers:{'Accept':'application/json'}, body: new FormData(form)})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
      .then(function(res){
        if (btn){ btn.disabled = false; if (label !== null) btn.innerHTML = label; }
        if (!res.ok){
          alert(res.d && res.d.description ? res.d.description : 'Sorry, that item could not be added.');
          return;
        }
        return fetchCart().then(open);
      })
      .catch(function(){
        if (btn){ btn.disabled = false; if (label !== null) btn.innerHTML = label; }
        form.submit();
      });
  }, true);

  document.addEventListener('click', function(e){
    var cartLink = e.target.closest && e.target.closest('.nav-cart');
    if (cartLink){ e.preventDefault(); fetchCart().then(open); return; }

    if (e.target.closest && e.target.closest('[data-cd-close]')){ close(); return; }
    if (e.target === backdrop){ close(); return; }

    var line = e.target.closest && e.target.closest('.eoa-cd-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var qty = parseInt(line.querySelector('.eoa-cd-qty span').textContent, 10) || 1;
    if (e.target.closest('[data-cd-inc]')) change(key, qty + 1);
    else if (e.target.closest('[data-cd-dec]')) change(key, Math.max(0, qty - 1));
    else if (e.target.closest('[data-cd-rm]')) change(key, 0);
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer.classList.contains('on')) close();
  });

  fetchCart();
  window.eoaOpenCart = function(){ fetchCart().then(open); };
})();
